import script from "./PopupReviewPostMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewPostMobile.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewPostMobile.vue?vue&type=style&index=0&id=41f6dacc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f6dacc"]])

export default __exports__